import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventComponent } from './event.component';
import { EventFormComponent } from './event-form/event-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {RouterModule} from '@angular/router';
import {DocumentModule} from '../document/document.module';
import {PipesModule} from '../../pipes/pipes.module';
import {CurrencyInputModule} from "../currency-input/currency-input.module";
import {MatCheckboxModule} from "@angular/material/checkbox";



@NgModule({
    declarations: [EventComponent, EventFormComponent],
    exports: [
        EventComponent,
        EventFormComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatMenuModule,
        MatDialogModule,
        MatRippleModule,
        MatDatepickerModule,
        MatIconModule,
        NgxMatDatetimePickerModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        RouterModule,
        DocumentModule,
        PipesModule,
        CurrencyInputModule,
        MatCheckboxModule
    ]
})
export class EventModule { }
